import { Fragment, ReactNode } from 'react';
import { match } from 'ts-pattern';
import { withForm } from './dynamic-form';
import { mapQuestionToFieldProps } from '../utils/map-question-to-field-props';
import { handleRevalidate } from '../utils/handle-revalidate-params';
import { QuestionDto } from '@maia/shared';
import { isNil } from 'es-toolkit';

export const FieldMapper = withForm({
  props: {
    question: {} as QuestionDto,
    onRevalidate: handleRevalidate,
  },
  render: ({ form, question, onRevalidate }) => {
    if (question.isEditable === false) {
      return <></>;
    }

    return (
      <form.AppField
        name={question.guid}
        validators={{
          onChange: ({ value }) => {
            if (question.isRequired && isNil(value)) {
              return 'Dit veld is verplicht';
            }
            return undefined;
          },
        }}
        listeners={{
          onChange: () => {
            if (question.revalidateOnChange) {
              return onRevalidate(form.state.values);
            }
          },
        }}
      >
        {(field) => (
          <Fragment key={question.guid}>
            {match(question)
              .returnType<ReactNode>()
              .with({ inputType: 'text' }, (q) => {
                return <field.TextField {...mapQuestionToFieldProps(q)} />;
              })
              .with({ inputType: 'number' }, (q) => (
                <field.NumberField {...mapQuestionToFieldProps(q)} />
              ))
              .with({ inputType: 'money' }, (q) => (
                <>
                  <field.MoneyField {...mapQuestionToFieldProps(q)} />
                </>
              ))
              .with(
                { inputType: 'radio' },
                { inputType: 'toggle_group' },
                { inputType: 'question' },
                { inputType: 'multiple_choice' },
                (q) => <field.RadioField {...mapQuestionToFieldProps(q)} />,
              )
              .with({ inputType: 'date' }, (q) => (
                <field.DateField {...mapQuestionToFieldProps(q)} />
              ))
              .with({ inputType: 'switch' }, (q) => (
                <field.RadioSwitchField {...mapQuestionToFieldProps(q)} />
              ))
              .with({ inputType: 'toggle_group' }, (q) => (
                <field.ToggleGroupField {...mapQuestionToFieldProps(q)} />
              ))
              .with({ inputType: 'attachments' }, (q) => {
                return (
                  <field.UploadAttachments {...mapQuestionToFieldProps(q)} />
                );
              })
              .with({ inputType: 'dropdown' }, (q) => (
                <field.SelectField {...mapQuestionToFieldProps(q)} />
              ))
              .otherwise((q) => (
                <h1>Unknown {q.inputType}</h1>
              ))}
          </Fragment>
        )}
      </form.AppField>
    );
  },
});
